<template>
  <main id="main">
    <Loading :isProcessing="isProcessing"></Loading>
    <DiagCorpHeader
      v-if="!isRendering"
      :corpName="corpName"
      :corporateFeatureInfoLabels="corporateFeatureInfoLabels"
      :corporateSelectable="isAdmin"
      :manageCorpName="manageCorpName"
      :isAdmin="isAdmin"
      :isDiagAvailablePlan="isDiagAvailablePlan"
      @select-corporate="emitSelectCorpList"
    ></DiagCorpHeader>
    <DiagHeaderNavigation
      :answeredDiagResultItemsCountTotal="score"
      :diagItemsCountTotal="totalScore"
    ></DiagHeaderNavigation>

    <div class="l-contents" v-if="!isRendering">
      <DiagNavigation
        :isAdmin="isAdmin"
        :isIpo="isIpo"
      ></DiagNavigation>

      <div class="l-contentsBox">
        <div class="l-contentsSection">
          <p class="l-text">
            「監査の管理」では「監査フォーム」で「いいえ」「不明」と回答された項目を「課題」として表示します。<br>
            「監査の管理」で対応期限や優先度を設定し、労務改善に活かしてください。
          </p>
        </div>
        <div class="l-contentsSection">

          <div class="l-diagnosisSearch">
            <div class="l-diagnosisSearch__header" @click="showSearch(!isSearch)">
              <p class="l-diagnosisSearch__label"><img src="@/assets/img/common/icon-search.svg" alt="">絞り込み</p>
              <div class="l-diagnosisSearch__selected">
                <dl>
                  <dt>カテゴリ</dt>
                  <dd>{{ selectedDiagSectionLabel }}</dd>
                </dl>
              </div>
            </div>
            <transition name="tasksearch-fade">
              <div class="l-diagnosisSearch__body" v-show="isSearch">
                <div class="l-diagnosisSearch__section">
                  <label class="l-formGroup__label">カテゴリ</label>
                  <ul class="l-inputList">
                    <li v-for="diagSection in this.diagSectionListForSearch" :key="diagSection.sectionId">
                      <label class="l-checkbox">
                        <input type="checkbox"
                          :value="diagSection.sectionId"
                          v-model="searchForm.diagSectionIds" />
                        {{ diagSection.label }}
                      </label>
                    </li>
                  </ul>
                </div>
                <div class="l-diagnosisSearch__bottom">
                  <div class="btn-basic is-inlne" @click="search()"><a>チェックした項目で絞り込み</a></div>
                </div>
              </div>
            </transition>
          </div>
          <table class="table-base audit-table  table-select">
            <colgroup>
              <col style="width: 50px;" v-if="!isIpo">
              <col style="width: 120px;" v-if="isIpo">
              <col>
              <col>
              <col>
            </colgroup>
            <thead>
              <tr class="is-sort">
                <th v-if="!isIpo" @click="sortByRiskLevel()" :class="{'is-sorted' : searchForm.sortKey.isSortedByRiskLevel, 'is-descending' : (searchForm.sortKey.isSortedByRiskLevel && !searchForm.sortKey.isAscendingSort ), 'is-ascending' : (searchForm.sortKey.isSortedByRiskLevel && searchForm.sortKey.isAscendingSort ) }">
                  <span>リスク</span>
                </th>
                <th v-if="isIpo" @click="sortByIpoLevel()" :class="{'is-sorted' : searchForm.sortKey.isSortedByIpoLevel, 'is-descending' : (searchForm.sortKey.isSortedByIpoLevel && !searchForm.sortKey.isAscendingSort ), 'is-ascending' : (searchForm.sortKey.isSortedByIpoLevel && searchForm.sortKey.isAscendingSort ) }">
                  <span>IPO重要度</span>
                </th>
                <th @click="sortByTask()" :class="{'is-sorted' : searchForm.sortKey.isSortedByTask, 'is-descending' : (searchForm.sortKey.isSortedByTask && !searchForm.sortKey.isAscendingSort ), 'is-ascending' : (searchForm.sortKey.isSortedByTask && searchForm.sortKey.isAscendingSort ) }">
                  <span>項目名</span>
                </th>
                <th @click="sortByIsHighPriority()" class="t-center" :class="{'is-sorted' : searchForm.sortKey.isSortedByIsHighPriority, 'is-descending' : (searchForm.sortKey.isSortedByIsHighPriority && !searchForm.sortKey.isAscendingSort ), 'is-ascending' : (searchForm.sortKey.isSortedByIsHighPriority && searchForm.sortKey.isAscendingSort ) }">
                  <span>優先度</span>
                </th>
                <th @click="sortByDueDate()" class="t-center" :class="{'is-sorted' : searchForm.sortKey.isSortedByDueDate, 'is-descending' : (searchForm.sortKey.isSortedByDueDate && !searchForm.sortKey.isAscendingSort ), 'is-ascending' : (searchForm.sortKey.isSortedByDueDate && searchForm.sortKey.isAscendingSort ) }">
                  <span>対応期限</span>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr @click="goTaskDetail(resultItem.diagResultItemId)" v-for="resultItem in taskList" :key="resultItem.diagResultItemId">
                <td v-if="!isIpo">
                  <span class="label"
                    :class="resultItem.riskLevelDisplayLabelClass"
                    :data-tooltip="resultItem.riskLevelDescription"
                    @mouseover="toggle(resultItem.diagResultItemId)" @mouseleave="toggleb(resultItem.diagResultItemId)">
                    <span class="tooltip is-right" :id="resultItem.diagResultItemId" >{{resultItem.riskLevelDescription}}</span>
                    {{ resultItem.riskLevelName }}
                  </span>
                </td>
                <td v-if="isIpo">
                  <span class="label-level"
                    :class="resultItem.ipoLevelDisplayLabelClass"
                    :data-tooltip="resultItem.ipoLevelDescription"
                    @mouseover="toggle(resultItem.diagResultItemId)" @mouseleave="toggleb(resultItem.diagResultItemId)">
                    <span class="tooltip is-right" :id="resultItem.diagResultItemId" >{{resultItem.ipoLevelDescription}}</span>
                    {{ resultItem.ipoLevelName }}
                  </span>
                </td>
                <td>
                  <p class="number-text">
                    <span class="number">{{ resultItem.sortOrder }}</span>
                    <span class="text" style="white-space: pre-line;">{{ resultItem.task }}</span>
                  </p>
                </td>
                <td class="t-center">
                  <span v-if="resultItem.isHighPriority">高</span>
                  <span v-else>-</span>
                </td>
                <td class="t-center" :class="{'caution' : resultItem.isCaution}">
                  <template v-if="resultItem.dueDate">
                    {{ $dayjs(resultItem.dueDate).format("YYYY年MM月DD日") }}
                    <img v-if="resultItem.isCaution" src="@/assets/img/common/icon-caution.svg" alt="" width="22" height="22">
                  </template>
                  <template v-else>未設定</template>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <pagination
          :pageInfo="pageInfo"
          @change-page="emitChangePage">
        </pagination>
      </div>
    </div>
    <transition name="tutorialmodal-fade">
      <TaskListTutorial
        v-show="isShowTutorial"
        @close-tutorial-modal="showTutorialModal(false)"
      ></TaskListTutorial>
    </transition>
  </main>
</template>

<script src="https://code.jquery.com/jquery-3.5.1.min.js "></script>

<script>
import Loading from '@/components/parts/common/Loading.vue';
import Pagination from '@/components/parts/common/Pagination.vue';
import DiagCorpHeader from '@/components/parts/diag/DiagCorpHeader.vue';
import DiagHeaderNavigation from '@/components/parts/diag/DiagHeaderNavigation.vue';
import DiagNavigation from '@/components/parts/diag/DiagNavigation.vue';
import TaskListTutorial from '@/components/parts/tutorial/TaskListTutorial.vue';

export default {
  components: {
    Loading,
    Pagination,
    DiagCorpHeader,
    DiagHeaderNavigation,
    DiagNavigation,
    TaskListTutorial,
  },
  computed: {
    diagResultId() {
      return this.$store.getters['diag/getDiagResultId'];
    },
    corpId() {
      return this.$store.getters['diag/getCorpId'];
    },
    corpName() {
      return this.$store.getters['diag/getCorpName'];
    },
    corporateFeatureInfoLabels() {
      return this.$store.getters['diag/getCorporateFeatureInfoLabels'];
    },
    selectedDiagSectionLabel() {
      if (this.searchForm.diagSectionIds.length == 0) {
        return '設定無し';
      }
      let diagSectionList = this.diagSectionListForSearch;
      let selectedDiagSectionList = [];
      this.searchForm.diagSectionIds.forEach(diagSectionId => {
        let selectedDiagSection = diagSectionList.find(ds => ds.sectionId == diagSectionId);
        selectedDiagSectionList.push(selectedDiagSection.label);
      }, diagSectionList)
      return selectedDiagSectionList.join(',');
    },
    manageCorpName() {
      return this.$store.getters['auth/getUser'].manageCorpNm;
    },
  },
  watch: {
    async corpId() {
      this.$store.dispatch('diag/setDiagResultId', null);
      this.$router.push({ name: 'diag-top' });
    },
    isAllSectionSelected() {
      this.searchForm.isAllSectionSearch = this.isAllSectionSelected;
    }
  },
  data() {
    return {
      isProcessing: false,
      isRendering: false,
      isSearch: false,
      pageInfo: {},
      taskList: [],
      diagResult: {
        score: 0,
        totalScore: 0,
      },
      searchForm: {
        diagSectionIds: [],
        sortKey: {
          isDefaultSort: true,
          isSortedByRiskLevel: false,
          isSortedByIpoLevel: false,
          isSortedByTask:  false,
          isSortedByIsHighPriority: false,
          isSortedByDueDate: false,
          isAscendingSort: false,
        },
      },
      diagSectionListForSearch: [],
      isAdmin: false,
      isDiagAvailablePlan: false,
      isShowTutorial: false,
      score: 0,
      totalScore:0,
      isIpo:false,
    }
  },
  created: async function () {
    this.isRendering = true;
    this.isProcessing = true;

    const authority = await this.$store.dispatch('auth/getAuthority')
    this.isAdmin = authority.isAdmin;
    this.isDiagAvailablePlan = authority.isDiagAvailablePlan;

    this.searchForm = this.$store.getters['diag/getTaskListSearchForm'];
    await this.getTaskList(this.diagResultId, 1);
    this.isProcessing = false;
    this.showTutorialModal(this.$store.getters['auth/getUser'].tutorial.isShowTaskListTutorial);
  },
  methods: {
    toggle(id) {
      var tooltip = $('#'+id);
      tooltip.fadeIn(200);
    },
    toggleb(id) {
      var tooltip = $('#'+id);
      tooltip.fadeOut(200);
    },
    showSearch(value) {
      this.isSearch = value;
    },
    emitChangePage(page) {
      this.getTaskList(this.diagResultId, page)
    },
    async search() {
      await this.getTaskList(this.diagResultId, 1);
    },
    async getTaskList(diagResultId, page) {
      this.isRendering = true;
      this.isProcessing = true;
      let res = await this.$axios.post('/ld/api/diag/getTaskList', {
        page: page,
        diagResultId: diagResultId,
        sortKey: this.searchForm.sortKey,
        diagSectionIds: this.searchForm.diagSectionIds,
        corpId: this.corpId,
      });
      if (res) {
        this.taskList = res.data.taskList.data;
        this.diagResult = res.data.diagResult;
        this.isIpo = res.data.isIpo;
        this.score = res.data.diagResultScore.answeredCount;
        this.totalScore = res.data.diagResultScore.totalCount;

        res.data.diagSectionListForSearch.forEach(diagSection => {
          if (!this.diagSectionListForSearch.some(section => section.sectionId === diagSection.sectionId)) {
            this.diagSectionListForSearch.push(diagSection);
          }
        });
        this.pageInfo = {
          currentPage: res.data.taskList.current_page,
          lastPage: res.data.taskList.last_page,
          total: res.data.taskList.total,
          from: res.data.taskList.from,
          to: res.data.taskList.to,
        };
      }
      this.$nextTick(() => {
        this.isSearch = false;
        this.isProcessing = false;
        this.isRendering = false;
      });
    },
    goTaskDetail(diagResultItemId) {
      this.$store.dispatch('diag/setDiagResultItemId', diagResultItemId);
      let searchForm = this.searchForm;
      this.$store.dispatch('diag/setTaskListSearchForm', searchForm);

      this.$router.replace({path: '/diag/task/'+this.corpId+'/'+this.diagResultId+'/'+diagResultItemId+'/task/detailparam'});
    },
    async sortByRiskLevel() {
      if (this.searchForm.sortKey.isSortedByRiskLevel) {
        this.searchForm.sortKey.isAscendingSort = !this.searchForm.sortKey.isAscendingSort;
      } else {
        this.searchForm.sortKey = {
          isDefaultSort: false,
          isSortedByRiskLevel: true,
          isSortedByIpoLevel: false,
          isSortedByTask:  false,
          isSortedByIsHighPriority: false,
          isSortedByDueDate: false,
          isAscendingSort: false,
        };
      }
      await this.getTaskList(this.diagResultId, 1);
    },
    async sortByIpoLevel() {
      if (this.searchForm.sortKey.isSortedByIpoLevel) {
        this.searchForm.sortKey.isAscendingSort = !this.searchForm.sortKey.isAscendingSort;
      } else {
        this.searchForm.sortKey = {
          isDefaultSort: false,
          isSortedByIpoLevel: true,
          isSortedByRiskLevel: false,
          isSortedByTask:  false,
          isSortedByIsHighPriority: false,
          isSortedByDueDate: false,
          isAscendingSort: false,
        };
      }
      await this.getTaskList(this.diagResultId, 1);
    },
    async sortByTask() {
      if (this.searchForm.sortKey.isSortedByTask) {
        this.searchForm.sortKey.isAscendingSort = !this.searchForm.sortKey.isAscendingSort;
      } else {
        this.searchForm.sortKey = {
          isDefaultSort: false,
          isSortedByRiskLevel: false,
          isSortedByIpoLevel: false,
          isSortedByTask: true,
          isSortedByIsHighPriority: false,
          isSortedByDueDate: false,
          isAscendingSort: false,
        };
      }
      await this.getTaskList(this.diagResultId, 1);
    },
    async sortByIsHighPriority() {
      if (this.searchForm.sortKey.isSortedByIsHighPriority) {
        this.searchForm.sortKey.isAscendingSort = !this.searchForm.sortKey.isAscendingSort;
      } else {
        this.searchForm.sortKey = {
          isDefaultSort: false,
          isSortedByRiskLevel: false,
          isSortedByIpoLevel: false,
          isSortedByTask: false,
          isSortedByIsHighPriority: true,
          isSortedByDueDate: false,
          isAscendingSort: false,
        };
      }
      await this.getTaskList(this.diagResultId, 1);
    },
    async sortByDueDate() {
      if (this.searchForm.sortKey.isSortedByDueDate) {
        this.searchForm.sortKey.isAscendingSort = !this.searchForm.sortKey.isAscendingSort;
      } else {
        this.searchForm.sortKey = {
          isDefaultSort: false,
          isSortedByRiskLevel: false,
          isSortedByIpoLevel: false,
          isSortedByTask: false,
          isSortedByIsHighPriority: false,
          isSortedByDueDate: true,
          isAscendingSort: false,
        };
      }
      await this.getTaskList(this.diagResultId, 1);
    },
    emitSelectCorpList(params) {
      this.$store.dispatch('diag/setCorpId', params.corpId);
      this.$store.dispatch('diag/setCorpName', params.corpNm);
    },
    showTutorialModal(value) {
      this.isShowTutorial = value;
    },
  }
}
</script>

<style scoped>
.tasksearch-fade-enter-active {
  transition: height .1s ease-in-out;
}
.tasksearch-fade-leave-active {
  transition: height .1s ease-in-out;
}
.tasksearch-fade-enter-to, .tasksearch-fade-leave {
   overflow: hidden;
}
.tasksearch-fade-enter, .tasksearch-fade-leave-to {
   overflow: hidden;
}

.tutorialmodal-fade-enter-active {
  transition: all .2s ease;
}
.tutorialmodal-fade-leave-active {
  transition: all .2s ease;
}
.tutorialmodal-fade-enter {
  transform: translateY(-50px);
  opacity: 0;
}
.tutorialmodal-fade-leave-to {
  transform: translateY(-50px);
  opacity: 0;
}
</style>
